import "./Errorsummery.scss";

const fieldLabels: Record<string, string> = {
  principalFirstName: "Principal first name",
  principalLastName: "Principal last name",
  principalMobileNo: "Principal work mobile",
  officeEmail: "Office email",
  website: "Website",
  officeMobileNo: "Office contact",
  houseNo: "House or building number",
  streetName: "Street name",
  city: "City/suburb",
  state: "State",
  country: "Country",
  postCode: "Postcode",

  agencyTradingName: "Agency Trading Name",
  agencyLegalName: "Agency Legal Name",
  abnNumber: "ABN/Business Number",
  acnNumber: "ACN/Tax Number",
  agency_type: "Agency Type",
  brand_id: "Please select your brand",

  profileLogo: "Agency/Office logo",
};

const ErrorSummary = ({ errors }: { errors: Record<string, string> }) => {
  const errorEntries = Object.entries(errors);
  if (!errorEntries.length) return null;

  return (
    <>
      <div className="error-summary">
        <div className="error-header">
          <span className="error-icon">!</span>
          <span>Errors in form!</span>
        </div>
        <div className="error-message">
          Please fix the following errors to submit the request
        </div>
      </div>
      <div>
        <ul className="error-list">
          {errorEntries.map(([field, message]) => (
            <li key={field}>
              {message.startsWith("Please")
                ? message
                : `${fieldLabels[field] || field} ${message}`}
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default ErrorSummary;
